module.exports = __webpack_public_path__ + "static/media/couches-9.fdd8e7a8.jpg";